<template
  ><div>
    <el-dialog
      :close-on-click-modal="false"
      title="关联产品"
      :visible.sync="visible"
      width="960px"
      top="10vh"
      class="relateOrder"
      :before-close="handleClose"
    >
      <div style="max-height: 69vh;overflow: auto;">
        <div class="table">
          <div class="table-list">
            <div class="item">
              <div class="content">
                <div class="left">
                  <img :src="order.picUrl ? order.picUrl : noImage" alt="" />
                </div>
                <div class="right">
                  <div
                    v-if="order.title"
                    :title="order.title"
                    class="title text-ellipsis"
                    style="width: 350px;margin: 0 0 12px 0;"
                  >
                    {{ order.title }}
                  </div>
                  <div
                    v-if="order.merchantSku"
                    :title="order.merchantSku"
                    class="title text-ellipsis"
                    style="width: 350px;margin: 0 0 12px 0;"
                  >
                    {{ order.merchantSku }}
                  </div>
                  <div
                    v-if="order.properName"
                    :title="
                      order.properName ? order.properName : order.properName
                    "
                    class="title text-ellipsis"
                    style="width: 350px;margin: 0 0 12px 0;"
                  >
                    {{ order.properName ? order.properName : order.properName }}
                  </div>
                  <div v-if="order.properVal" class="list">
                    <div class="name">颜色</div>
                    <div class="value">
                      {{ order.properVal.split(":")[0] }}
                    </div>
                  </div>
                  <div v-if="order.properVal" class="list">
                    <div class="name">尺码</div>
                    <div class="value">
                      {{ order.properVal.split(":")[1] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="content">
                <div class="left">
                  <img :src="mainPic ? mainPic : noImage" alt="" />
                </div>
                <div class="right">
                  <div class="list">
                    <div class="name">成品编号：</div>
                    <div class="value">
                      <el-input
                        v-model="toMatch.designId"
                        class="input"
                        size="small"
                        @change="getTargetItem"
                        @keyup.enter="getTargetItem"
                        style="width:169px"
                      />
                      <el-button
                        size="small"
                        style="margin: 0 0 0 5px;"
                        @click="handleSelectDesign"
                        icon="el-icon-search"
                        circle
                      ></el-button>
                    </div>
                  </div>
                  <div class="sku-attr">
                    <div class="sku-name">颜色</div>
                    <div class="sku-detail">
                      <a
                        :style="{ background: dictMap['color'][color] }"
                        :class="{ 'is-select': currentAttr.color === color }"
                        @click="handleSelectColor(color)"
                        class="sku-color"
                        v-for="(color, index) in attribute['颜色']"
                        :key="index"
                        :title="color"
                      ></a>
                    </div>
                  </div>
                  <div class="sku-attr">
                    <div class="sku-name">尺码</div>
                    <div class="sku-detail">
                      <a
                        :class="{ 'is-select': currentAttr.size === size }"
                        @click="handleSelectSize(size)"
                        class="sku-size"
                        v-for="(size, index) in attribute['尺码']"
                        :key="index"
                        >{{ size }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取消</el-button>
        <el-button type="primary" @click="sure" size="small">
          保存
        </el-button>
      </span>
    </el-dialog>
    <SelectDesign
      @onClose="handleCloseDesign"
      :visible="showSelect"
      @update="handleChooseDesign"
    ></SelectDesign>
  </div>
</template>

<script>
import { matchSku, handReal } from "@/api/order/fba"
import { getCartInfo, getCartMatchInfo } from "@/api/customProduct/design"
import noImage from "@/assets/images/no_image.png"
import { mapGetters } from "vuex"
import SelectDesign from "./SelectDesign"

export default {
  name: "FbaRelate",
  data() {
    return {
      toMatch: {
        designId: "",
        picUrl: "",
        proName: "",
        attribute: "",
        num: "",
      },
      sizeList: [],
      colorList: [],
      form: {
        fbaPlanId: "",
        skuId: "",
      },
      currentAttr: {
        color: "",
        size: "",
      },
      detail: {},
      attribute: {},
      mainPic: "",
      noImage: noImage,
      showSelect: false,
    }
  },
  components: { SelectDesign },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    order: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          this.resetForm()
          if (this.order.afterDesignId) {
            this.toMatch.designId = this.order.afterDesignId
            this.getTargetItem(this.toMatch.designId)
            // this.currentAttr = {
            //   color: this.order.afterProperVal.split(":")[0],
            //   size: this.order.afterProperVal.split(":")[1],
            // }
            this.selectSku()
          }
        }
      },

      immediate: true,
    },
  },
  methods: {
    async getTargetItem(value) {
      try {
        this.currentAttr = {
          color: "",
          size: "",
        }
        let result = await getCartMatchInfo(value)
        if (result.data.length > 0) {
          this.mainPic = result.data[0].skuList[0].mainPic.picUrl

          this.detail = result.data[0]
          this.attribute = JSON.parse(result.data[0].attribute)
        } else {
          this.msgError("没有匹配的商品")
        }
      } catch (error) {
        let designId = this.toMatch.designId
        this.resetForm()
        this.toMatch.designId = designId
      }
    },
    changeProper(data, index, item) {
      let skuId = ""
      let pId = ""
      let properName = ""
      const properVal0 = item.properVal.split(":")[0]
      const properVal1 = item.properVal.split(":")[1]
      let newProperVal = ""

      if (index === 0) {
        newProperVal = data + ":" + properVal1
      }

      if (index === 1) {
        newProperVal = properVal0 + ":" + data
      }

      this.currentOrderSku.skuList.map((el) => {
        if (el.properVal === newProperVal) {
          skuId = el.skuId
          pId = el.pId
          properName = el.properName
        }
      })

      item.properVal = newProperVal
      item.skuId = skuId
      item.properName = properName
      item.pId = pId
    },
    sure() {
      if (this.form.skuId === "") {
        this.$message.error("请选择需要关联的产品")
        return
      }

      handReal({
        fbaPlanId: this.order.fbaPlanId,
        skuId: this.form.skuId,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("关联成功")
            this.$emit("onOk")
          } else {
            this.resetForm()
            this.$message.error(res.msg)
          }
        })
        .catch((error) => {
          this.resetForm()
          this.$message.error(error.msg)
        })
    },
    resetForm() {
      this.attribute = {}
      this.mainPic = ""
      this.form = {
        fbaPlanId: "",
        skuId: "",
      }
      this.toMatch = {
        designId: "",
        picUrl: "",
        proName: "",
        attribute: "",
        num: "",
      }
      this.currentAttr = {
        color: "",
        size: "",
      }
    },
    handleClose() {
      this.$emit("onClose")
    },
    handleSelectColor(color) {
      this.currentAttr.color = color
      this.selectSku()
    },
    handleSelectSize(size) {
      this.currentAttr.size = size
      this.selectSku()
    },
    handleChooseDesign({ designId, picUrl }) {
      this.toMatch.designId = designId
      this.mainPic = picUrl
      this.getTargetItem(designId)
      this.showSelect = false
    },
    selectSku() {
      for (let record of this.detail.skuList) {
        record.properVal = record.properVal.replace(/\\/g, "")
        if (
          record.properVal ===
          `${this.currentAttr.color}:${this.currentAttr.size}`
        ) {
          this.form.skuId = record.skuId
          this.mainPic = record.picList[0].picUrl
          break
        }
      }
    },
    handleSelectDesign() {
      this.showSelect = true
    },
    handleCloseDesign() {
      this.showSelect = false
    },
  },
}
</script>

<style scoped lang="scss">
.pd10 {
  padding: 5px 10px;
  border-top: 1px solid #ebeef5;
}

.relateOrder {
  font-size: 12px;
}

.relateOrder .line {
  display: flex;
  height: 30px;
  align-items: center;
}

.relateOrder .line .title {
  width: 60px;
}

.table {
  border: 1px solid #ebeef5;
}

.table .top {
  display: flex;
  background: #f5f7fa;
  height: 36px;
  align-items: center;
}

.table .top .item {
  width: 50%;
  display: flex;
}

.table .top .item .left {
  width: 50px;
  text-align: center;
}

.table .top .item .right {
  width: 328px;
  text-align: center;
}

.table .table-list {
  display: flex;
  flex-wrap: wrap;
}

.table .table-list .item {
  width: 50%;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  border-bottom: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
  display: flex;
  justify-content: center;
}

.table .table-list .item:nth-child(2n) {
  border-right: 0;
}

.table .table-list .item:nth-last-child(2),
.table .table-list .item:last-child {
  border-bottom: 0;
}

.table .table-list .item .index {
  width: 40px;
  text-align: left;
  box-sizing: border-box;
  padding-left: 10px;
}

.table .table-list .item .content {
  display: flex;
  flex-direction: column;
  .left {
    width: 250px;
    height: 250px;
    margin: 0 auto;
    border: 1px solid #ebeef5;
    margin-bottom: 20px;

    img {
      width: 100%;
      height: 100%;
    }
  }
  .right {
    display: flex;
    flex-direction: column;

    .title {
      font-size: 14px;
      margin-bottom: 10px;
    }

    .list {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      width: 300px;
      height: 32px;

      .name {
        width: 85px;
      }

      .value {
        width: 100%;
      }
    }
  }
}
.sku-attr {
  overflow: hidden;
  padding: 0 0 0 8px;
  .sku-name {
    margin: 0 32px 0 0;
    float: left;
    line-height: 30px;
  }
  .sku-detail {
    float: left;
    margin: 5px 0 0 0;
    width: calc(100% - 58px);
    line-height: 30px;
  }
}
.sku-color {
  margin: 0 8px 0 0;
  cursor: pointer;
  width: 29px;
  height: 29px;
  display: inline-block;
  padding: 0;
  transition: all 0.5s ease-in-out;
  border: 2px solid transparent;
  box-shadow: 0 0 0 1px #ddd;
}
.sku-size {
  color: #333;
  font-size: 12px;
  font-weight: 400;
  line-height: 30px;
  text-transform: capitalize;
  display: inline-block;
  margin: 0;
  min-width: 30px;
  overflow: hidden;
  text-align: center;
  background-color: #f9f9f9;
  border-radius: 7px;
  transition: all 0.5s ease-in-out;
  padding: 0 4px;
  margin: 0 12px 5px 0;

  border: 2px solid transparent;
  box-shadow: 0 0 0 1px #ddd;
  cursor: pointer;
  box-sizing: border-box;
}
.is-select {
  border: 2px solid #f25551;
}
.sku-price {
  font-size: 20px;
}
</style>
